import { defineRouting } from 'next-intl/routing';
export const routing = defineRouting({
    locales: [
        'en',
        'ar',
        'es',
        'fr'
    ],
    defaultLocale: 'en',
    localePrefix: 'as-needed'
});
